import * as React from 'react'
import { type IconProps } from './types'
/**
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB0PSIxNzI0MTQyODE1NzcwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjMwMTk3IiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZiI+PHBhdGggZD0iTTUzMy4zMzMzMzMgMjk4LjY2NjY2N2E4NS4zMzMzMzMgODUuMzMzMzMzIDAgMSAwIDAtMTcwLjY2NjY2NyA4NS4zMzMzMzMgODUuMzMzMzMzIDAgMCAwIDAgMTcwLjY2NjY2N3ogbTAgMjk4LjY2NjY2NmE4NS4zMzMzMzMgODUuMzMzMzMzIDAgMSAwIDAtMTcwLjY2NjY2NiA4NS4zMzMzMzMgODUuMzMzMzMzIDAgMCAwIDAgMTcwLjY2NjY2NnogbTAgMjk4LjY2NjY2N2E4NS4zMzMzMzMgODUuMzMzMzMzIDAgMSAwIDAtMTcwLjY2NjY2NyA4NS4zMzMzMzMgODUuMzMzMzMzIDAgMCAwIDAgMTcwLjY2NjY2N3oiIHAtaWQ9IjMwMTk4Ij48L3BhdGg+PC9zdmc+)
 */
export const ExpandIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 15, ...props }, forwardedRef) => {
    return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="30197"
        width={size}
        height={size}
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M533.333333 298.666667a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z m0 298.666666a85.333333 85.333333 0 1 0 0-170.666666 85.333333 85.333333 0 0 0 0 170.666666z m0 298.666667a85.333333 85.333333 0 1 0 0-170.666667 85.333333 85.333333 0 0 0 0 170.666667z"
          p-id="30198"
          fill={color}
        ></path>
      </svg>
    )
  },
)
